import React from 'react';
import { parseJson } from '../utils.tsx';

export const exportFinalNomenclatureCode = 'export-final-nomenclature';

const getAvailabilityDays = (parametersJson: string): number => {
    const parameters = parseJson<Record<string, unknown>>(parametersJson);
    const value = parameters?.availabilityDays;
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) return value;
    return 7;
};

const setAvailabilityDaysParameter = (parametersJson: string, days: number): string => {
    const parameters = parseJson<Record<string, unknown>>(parametersJson) ?? {};
    return JSON.stringify({ ...parameters, availabilityDays: days }, null, 2);
};

export const renderExportFinalNomenclatureParameters = ({
    editParams,
    onEditParamsChange
}: {
    editParams: string;
    onEditParamsChange: (value: string) => void;
}) => (
    <div className="operations-schedule-form">
        <div className="operations-schedule-fields">
            <div className="form-group-custom">
                <label className="form-label-custom">Доступность, дней</label>
                <input
                    className="form-input-custom"
                    type="number"
                    min={1}
                    max={365}
                    value={getAvailabilityDays(editParams)}
                    onChange={e => {
                        const val = parseInt(e.target.value, 10);
                        if (!isNaN(val) && val >= 1) {
                            onEditParamsChange(setAvailabilityDaysParameter(editParams, val));
                        }
                    }}
                />
            </div>
        </div>
    </div>
);

export const exportFinalNomenclatureExtension = {
    code: exportFinalNomenclatureCode,
    renderParameterEditor: renderExportFinalNomenclatureParameters,
    renderReport: () => null
};